import * as React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Steps, Button } from '@beehive/components';
import { ModalTip } from '@mpc/common/src/components';
import PropTypes from 'prop-types';
import messages from 'messages/Workbench/ProjectDetail/Progress';

export interface FlowNodeProps {
  id: number | string;
  mapNodes: any[];
  remindState: any;
  hasRemindButton?: boolean;
  handlerRemind: Function;
}
class FlowNode extends React.Component<FlowNodeProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
  };

  public handleOk = () => {
    return null;
  }

  public getRemindTime = (modify: any) => {
    if (modify) {
       const { updated_at } = modify;
       const countdown = 60 - moment().diff(moment(updated_at), 'minute');
       return countdown > 0 ? countdown : 1;
    } else {
      return 0;
    }
  }

  public renderStepTitle = (step: any, idx: number, options: any = {}) => {
    const { intl } = this.context;
    const { can_remind, state_nofity_record } = options;
    const childItems = [
      <div className="title" key="title">{step.state_name}</div>,
      (
        <ModalTip
          key="remindBtn"
          componentClass={Button}
          className="remind-btn"
          disabled={!can_remind}
          size="small"
          type="primary"
          modalConfig={{
            title: intl.formatMessage(messages.remindModalTitle),
            onOk: this.handleOk,
          }}
        >
          {intl.formatMessage(messages.redmind)}
        </ModalTip>
      ),
      !can_remind && (
        <div className="color-disabled" key="remindTip">
          {intl.formatMessage(messages.remindTimeTip, { duration: this.getRemindTime(state_nofity_record) })}
        </div>
      ),
    ];
    if (idx % 2 === 1) {
      childItems.reverse();
    }
    return <div className={'step-title-child child-length' + childItems.filter((i) => !!i).length}>{childItems}</div>;
  }

  public render() {
    const {
      mapNodes,
      remindState: { can_remind, state_nofity_record },
      hasRemindButton,
    } = this.props;
    const current = mapNodes.findIndex((node: any) => !!node.is_current);
    return (
      <Steps progressDot current={current} type="alternate">
        {
          mapNodes.map((step: any, i: number, arr: any[]) => {
            return (
              <Steps.Step
                key={step.state_name}
                title={ hasRemindButton && step.is_current && i !== 0 && i !== mapNodes.length - 1 ?
                  this.renderStepTitle(step, i, { can_remind, state_nofity_record }) :
                  step.state_name
                }
              />
            );
          })
        }
      </Steps>
    );
  }
}

export default connect(undefined, undefined)(FlowNode);
